<template>
    <div class="window bg">
        <div class="container" v-bind:class="{'background-black':isLoading}">
            <menu-option v-bind:back-route="'/menu'"></menu-option>

            <transition :css="false" @enter="resultAnimation" appear>
                <div v-if="isAdviceShow" v-html="resultText.advice" class="dialog-red"></div>
            </transition>

            <transition :css="false" @enter="resultAnimation" appear>
                <div v-if=" isLoading" class="container_result-text">
                    <p v-html="text" class="loading-text"></p>
                </div>
            </transition>


            <div class="img-container"
                 v-bind:class="{'change-image' : showDialog, 'change-image-advice':isAdviceShow , 'img-share':next}" v-if="!next">
                <transition :css="false" @enter="resultAnimation" appear>
                    <img v-bind:src="imgSrc" class="rotate-90-cw img-container_loading-img" v-if="isLoading">
                </transition>
                <transition :css="false" @enter="resultAnimation" appear>

                    <img v-bind:src="imgSrc" class="img-container_advice" v-if="!isLoading">
                </transition>

            </div>


            <transition :css="false" @enter="resultAnimation" appear>
                <character-talk v-if="showDialog" v-bind:text="text" v-on:action="showAdvice"
                                v-bind:show-next="true" v-bind:is-blue="false"  v-bind:show-name="true"></character-talk>
            </transition>

            <div class="container_share" v-if="isAdviceShow">

                <social-sharing url="https://lets-talk-japanese.web.app"
                                title="Let's talk Japanese"
                                v-bind:description="resultText.advice"
                                quote="Let's talk japanese is a game who help you to define your level of japanese"
                                hashtags="letstalkjapanese"
                                inline-template>
                    <network network="twitter" class="share-option-container">
                        <img src="assets/img/twitter.png">
                    </network>
                </social-sharing>
                <social-sharing url="https://lets-talk-japanese.web.app"
                                title="Let's talk Japanese"
                                v-bind:description="resultText.advice"
                                quote="Let's talk japanese is a game who help you to define your level of japanese"
                                hashtags="letstalkjapanese"
                                inline-template>
                    <network network="facebook" class="share-option-container">
                        <img src="assets/img/facebook.png">
                    </network>
                </social-sharing>
                <social-sharing url="https://lets-talk-japanese.web.app"
                                title="Let's talk Japanese"
                                v-bind:description="resultText.advice"
                                quote="Let's talk japanese is a game who help you to define your level of japanese"
                                hashtags="letstalkjapanese"
                                inline-template>
                    <network network="line" class="share-option-container">
                        <img src="assets/img/line.png">
                    </network>
                </social-sharing>
                <span class="next" @click="goNext"><ruby>次<rt>つぎ</rt></ruby>へ</span>
            </div>

            <div v-if="next" class="next-btn">
                <button class="btn-primary" @click="goToNewPage(1)">もっと
                    <ruby>話
                        <rt>はな</rt>
                    </ruby>
                    す
                </button>
                <button class="btn-secondaire" @click="goToNewPage(2)">タイトルへ
                    <ruby>戻
                        <rt>もど</rt>
                    </ruby>
                    る
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import MenuOption from '../components/MenuOption'
    import CharacterTalk from '../components/CharacterTalk'
    import ProgressLoading from '../components/ProgressLoading'
    import anime from 'animejs'


    export default {
        name: "Result",
        components: {
            MenuOption,
            ProgressLoading,
            CharacterTalk
        },
        props: ['mode'],
        watch: {
            progress(newValue, oldValue) {
                console.log(newValue);
                  this.deleteProgress(newValue);
            }
        },
        methods: {
            showAdvice() {
                console.log('advice');
                this.isAdviceShow = true;
                this.showDialog = false;
            },
            deleteProgress(progress) {
                console.log(progress);
                if (progress === 100) {

                    this.setTextResult(this.getResult.status, this.getMode);
                    this.isLoading = !this.isLoading;
                    this.showDialog = !this.showDialog;
                }
            },
            setTextResult(status, mode) {
                if (mode === 'practice') {
                    if (status === 0) {
                        this.resultText = this.getResultNoNative;
                        this.imgSrc = this.getCharacter.badAnswerImg;

                    } else if (status === 1) {
                        this.resultText = this.getResultMedium;
                        this.imgSrc = this.getCharacter.goodAnswerImg;

                    } else if (status === 2) {
                        this.resultText = this.getResultNative;
                        this.imgSrc = this.getCharacter.goodAnswerImg;
                    }
                }
                if (mode === 'free') {
                    if (status === 0) {
                        this.resultText = this.getFreeTalkNoNative;
                        this.imgSrc = this.getCharacter.badAnswerImg;

                    } else if (status === 1) {
                        this.resultText = this.getFreeTalkMedium;
                        this.imgSrc = this.getCharacter.goodAnswerImg;

                    } else if (status === 2) {
                        this.resultText = this.getFreeTalkNative;
                        this.imgSrc = this.getCharacter.goodAnswerImg;
                    }
                }
                this.text = this.resultText.result;
            },
            goNext() {
                this.next = !this.next;
                this.isAdviceShow = !this.isAdviceShow
                this.imgSrc = this.getCharacter.loadingImg;
            },
            goToNewPage(type) {
                type == 1 ? this.$router.push('/menu') : this.$router.push('/');
            },
            resultAnimation(el, done) {
                anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'

                })
            }
        },
        computed: {
            ...mapGetters(['getCharacter', 'getResult', 'getResultNoNative', 'getResultMedium',
                'getResultNative', 'getFreeTalkMedium', 'getFreeTalkNoNative', 'getFreeTalkNative', 'getMode']),
            progress() {
                return this.getResult.progress;
            }
        },
        mounted() {
            this.text = this.loadingText;
            this.imgSrc = this.getCharacter.loadingImg;
        },
        data() {
            return {
                loadingText: '<ruby>採点中<rt>さいてんちゅう</rt></ruby>です。</br> <ruby>少々<rt>しょうしょう</rt></ruby>お<ruby>待<rt>ま</rt></ruby>ちください。',
                text: '',
                showNext: false,
                showDialog: false,
                isAdviceShow: false,
                isLoading: true,
                resultText: {},
                imgSrc: '',
                next: false
            }
        }
    }
</script>

<style scoped>
.background-black{
    background: #0000004d;;
}
    .change-image-advice{
        height: 70%;
        bottom: 0;
    }
</style>
